import { XCircle } from "lucide-react";
import Alert from "./Alert";
import Warning from "./Warning";

type Props = {
  children: React.ReactNode;
  error?: string;
  action?: {
    label: string;
    icon?: React.ReactNode;
    onAction: () => void;
  };
};

export default function WarningAlert({ children, error, action }: Props) {
  return (
    <div className="w-full mt-5">
      <Warning>{children}</Warning>
      {error && (
        <div className="mt-2">
          <Alert
            icon={<XCircle className="w-4 h-4" />}
            title="Something went wrong"
            subtitle={error}
          />
        </div>
      )}
      {action && (
        <div className="flex items-center justify-center mt-3">
          <button
            className="flex items-center gap-1.5 text-xs text-[--color-text-primary] underline hover:opacity-70 transition-opacity"
            onClick={action.onAction}
          >
            {action.icon}
            {action.label}
          </button>
        </div>
      )}
    </div>
  );
}
